import localstorage from './localstorage';

const CACHE_KEY_PREFIX = '@@auth0spajs@@';

export const removeAllTokens = (clientId?: string) => {
  if (!clientId) {
    return;
  }

  const cacheKey = `${CACHE_KEY_PREFIX}::${clientId}`;
  const auth0Keys = localstorage.get(cacheKey);

  if (auth0Keys && Array.isArray(auth0Keys.keys)) {
    auth0Keys.keys.forEach((key: string) => localstorage.remove(key));
    localstorage.remove(cacheKey);
  }
};

const createCache = () => {
  return {
    get: async (key: string) => {
      return localstorage.get(key);
    },

    set: async (key: string, value: unknown) => {
      localstorage.set(key, value);
      return;
    },

    remove: async (key: string) => {
      localstorage.remove(key);
      return;
    },
  };
};

export default createCache;
